import _ from "lodash";

export const USER_LOGIN_SUCCESS = "USER_LOGIN_SUCCESS";
export const USER_LOGOUT = "USER_LOGOUT";

export const userLoginSuccessAction = authorization => ({
	type: USER_LOGIN_SUCCESS,
	authorization
});

export const userLogoutAction = () => ({
	type: USER_LOGOUT
});

const AUTH_TOKEN_ID = "authToken";
export const getAuthToken = () => sessionStorage.getItem(AUTH_TOKEN_ID);
export const setAuthToken = token => sessionStorage.setItem(AUTH_TOKEN_ID, token);
export const clearAuthToken = () => sessionStorage.removeItem(AUTH_TOKEN_ID);

const initial_state = {
	isAuthorized: false,
	canWrite: false,
	demoOnly: true
};

export const userReducer = (state = initial_state, action) => {
	switch (action.type) {
	case USER_LOGIN_SUCCESS:
		return _.merge({}, state, {
			isAuthorized: true,
			canWrite: action.authorization.canWrite,
			demoOnly: action.authorization.demoOnly
		});
	case USER_LOGOUT:
		return _.merge({}, state, {
			isAuthorized: false,
			permissions: []
		});
	default:
		return state;
	}
};
